import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type EmailVerificationStatusQueryVariables = Types.Exact<{ [key: string]: never }>;

export type EmailVerificationStatusQuery = { __typename?: 'Query'; me?: { __typename?: 'User'; id: string; emailIsVerified: boolean } | null };

export const EmailVerificationStatusDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EmailVerificationStatus' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailIsVerified' },
                  arguments: [
                    { kind: 'Argument', name: { kind: 'Name', value: 'liveQuery' }, value: { kind: 'BooleanValue', value: true } },
                    { kind: 'Argument', name: { kind: 'Name', value: 'confirmVerification' }, value: { kind: 'BooleanValue', value: true } },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEmailVerificationStatusQuery__
 *
 * To run a query within a React component, call `useEmailVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailVerificationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmailVerificationStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EmailVerificationStatusQuery, EmailVerificationStatusQueryVariables>) {
  return ApolloReactHooks.useQuery<EmailVerificationStatusQuery, EmailVerificationStatusQueryVariables>(EmailVerificationStatusDocument, baseOptions);
}
export function useEmailVerificationStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EmailVerificationStatusQuery, EmailVerificationStatusQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<EmailVerificationStatusQuery, EmailVerificationStatusQueryVariables>(EmailVerificationStatusDocument, baseOptions);
}
export type EmailVerificationStatusQueryHookResult = ReturnType<typeof useEmailVerificationStatusQuery>;
export type EmailVerificationStatusLazyQueryHookResult = ReturnType<typeof useEmailVerificationStatusLazyQuery>;
export type EmailVerificationStatusQueryResult = Apollo.QueryResult<EmailVerificationStatusQuery, EmailVerificationStatusQueryVariables>;
